import { Injectable } from "@angular/core";

import { GetPagedBody, HttpService, HttpServiceBaseCRUD } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class EventRequestsService extends HttpService implements HttpServiceBaseCRUD {
  protected override get baseUrl(): string {
    return "eventrequests/";
  }

  add(body: any) {
    return this.post<any>({ APIName: "add", body, showAlert: true });
  }

  update(body: any) {
    return this.put<any>({ APIName: "update", body, showAlert: true });
  }

  remove(id: string) {
    return this.delete<any>({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: any) {
    return this.get<any>({ APIName: `get/${id}` });
  }

  getPaged(body: GetPagedBody<any>) {
    return this.getPagedRequest<any[]>({ APIName: "getpaged", body });
  }

  getAll() {
    return this.get<any[]>({ APIName: "getall" });
  }

  updateStatus(body: any) {
    return this.put<any>({ APIName: "update-status", body, showAlert: true });
  }
}
